import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { PreviewLaudos } from 'vivace-fluent-motion';

function Preview ({ url, show, setShow, pdf }) {
  const intl = useIntl()
  const [preview, setPreview] = useState(false);
  const [urlDocument, setUrlDocument] = useState('');

  useEffect(() => {
    let newUrl = url;
    if (show) {
       if (pdf){

        var base64str = pdf;
        var binary = atob(base64str.replace(/\s/g, ''));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }

        var blob = new Blob( [view], { type: "application/pdf" });
        newUrl = URL.createObjectURL(blob);
      }

      setUrlDocument(newUrl);
      setPreview(true);
    }
  }, [url, show]);

  return (
    <div style={{ display: preview ? 'initial' : 'none' }}>
      {urlDocument && (
        <PreviewLaudos
          messageTitle = {`${intl.formatMessage({id: 'dashboards.reports.printPreview'})}`}
          printLabel = {`${intl.formatMessage({id: 'dashboards.reports.printOut'})}`}
          saveLabel = {`${intl.formatMessage({id: 'general.requestsPanel.save'})}`}
          messageLoader={`${intl.formatMessage({id: 'message.loading'})}`}
          messageErroFile={`${intl.formatMessage({id: 'messages.noChargeReport'})}`}
          visible={preview}
          IdExamePedido={new Date().getTime()}
          allowcors={false}
          file={urlDocument}
          onOpened={() => {
            setPreview(false);
            setShow && setShow(false);
          }}
        />
      )}
    </div>
  );
}

export default Preview;



// WEBPACK FOOTER //
// ./src/componentes/PreviewURL/index.js